import type { FaireProductEntity } from "../../entity_types/product";

export const p_uspvdkstns: FaireProductEntity = {
  token: "p_uspvdkstns",
  type: "product",
  name: "Thank You No. 45",
  brandToken: "b_umfa9a7xcn",
  brandName: "Jaymes Paper",
  imageUrl:
    "https://cdn.faire.com/fastly/b696bcafa6a3f928415b8404415665c7330222662dfca7f0c12073fbd6da9f7f.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/bc77bb91ebf6deb8635f3b98c1c2c27a925a9324973942d0107fcf212b4fdec3.png",
    "https://cdn.faire.com/fastly/5ad90aeb42924df5aac8607a741122c964373e13d8cb5e1a5d2d2d1873fdbacc.jpeg",
    "https://cdn.faire.com/fastly/09dd9aeeaaf1e07663bf32d7885f42d1726e5776a346862c88d42d74919eafcd.jpeg",
    "https://cdn.faire.com/fastly/2b8c68b9d21865a5cfcaf728666bfb791fead30ca378ef38dec6ca9c54fb8d8a.jpeg",
  ],
  priceDollars: 3.75,
  description:
    '• A2 Folded 4.25" L × 5.5" W\n• "Thank You"\n• Fern or French Blue Cover Stock\n• Silver Foil Stamped\n• Natural Envelope\n• Blank interior\n• Made in Los Angeles',
  tags: [],
  msrpDollars: 7.5,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-07-23T05:55:12.655Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
